// Money display helpers (money-mode §7) shared by the client and the server's labels. Money is
// held and settled in integer lamports (`number`, always a safe integer); these helpers only
// convert for display. The server never uses them for ledger math, and the client never computes
// a player's value: it only formats the numbers the server sends.

import { LAMPORTS_PER_SOL } from './constants.js';

/** True for a valid lamport amount: a non-negative safe integer. */
export function isLamports(v: unknown): v is number {
  return typeof v === 'number' && Number.isSafeInteger(v) && v >= 0;
}

/** Lamports as SOL (display only; may be inexact in the last binary digit). */
export function lamportsToSol(lamports: number): number {
  return lamports / LAMPORTS_PER_SOL;
}

/** Lamports as USD at `solUsd` dollars per SOL (display only). 0 when the price is unknown. */
export function lamportsToUsd(lamports: number, solUsd: number): number {
  if (!(solUsd > 0) || !Number.isFinite(solUsd)) return 0;
  return (lamports / LAMPORTS_PER_SOL) * solUsd;
}
